import React, { useEffect, useState } from "react";
import axios from "axios";
import { FileText } from "lucide-react";
import { FiDownload } from "react-icons/fi";
import { Base_Url,fetchUser,UploadCsv } from "../../../../../config/config";
import toast from "react-hot-toast";


const PricingTemplateUpload = () => {
  const [zoneFile, setZoneFile] = useState(null);
  const [vasFile, setVasFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const cus_id = localStorage.getItem("cus_id");
  const [retailers, setRetailers] = useState([]);
  const [selectedRetailer, setSelectedRetailer] = useState("");
  const [selectedCourier, setSelectedCourier] = useState("");
  const [error, setError] = useState("");

  const courierPartners = [
    { id: "delhivery", name: "Delhivery" },
    { id: "movin", name: "Movin" },
    { id: "gati", name: "Gati" },
  ];
  const fetchRetailers = async () => {
    const url = Base_Url + fetchUser;
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          token: token,
          cus_id: cus_id,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.status === "success") {
        const transformedData = data.data.map((user) => {
          const capitalizedName =
            user.name.charAt(0).toUpperCase() + user.name.slice(1);
          return {
            value: user.id,
            label: `${capitalizedName} (${user.id})`,
          };
        });
        setRetailers(transformedData);
      } else {
        setError(data.message || "Failed to fetch retailers");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRetailers();
  }, []);

  /* ================= UPLOAD HANDLER ================= */
  const handleUpload = async () => {
    if (!selectedRetailer || !selectedCourier) {
      toast.error("Please select Retailer and Courier Partner");
      return;
    }

    if (!zoneFile || !vasFile) {
      toast.error("Please upload both CSV files");
      return;
    }

    const formData = new FormData();
    formData.append("retailer_id", selectedRetailer);
    formData.append("courier_partner", selectedCourier);
    formData.append("zone_pricing", zoneFile);
    formData.append("vas_pricing", vasFile);

    try {
      setLoading(true);

      const res = await axios.post(
        Base_Url  + UploadCsv,
        formData,
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Pricing uploaded successfully ✅");
    } catch (error) {
      toast.error("Failed to upload pricing ❌");
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (

    <div className="flex flex-col gap-4">
      {/* ================= DROPDOWNS ================= */}


            {/* ================= TEMPLATE DOWNLOAD ================= */}

      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20 rounded-xl p-4 border border-indigo-200 dark:border-indigo-800">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full">
              <FileText className="w-4 h-4 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-xs">Need a template?</h3>
              <p className="text-[11px] text-gray-600">
                Download sample CSV files
              </p>
            </div>
          </div>

          <div className="flex gap-2">
            <a
              href="/sampleFile/b2brate.csv"
              download
              className="px-3 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl text-xs flex items-center gap-1"
            >
              <FiDownload /> B2B Rate
            </a>

            <a
              href="/sampleFile/b2bratevas.csv"
              download
              className="px-3 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl text-xs flex items-center gap-1"
            >
              <FiDownload /> VAS Rate
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-3 sm:p-2 lg:p-4 mb-4 sm:mb-6 mt-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Retailer */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Select Retailer <span className="text-red-500">*</span>
          </label>
          <select
            value={selectedRetailer}
            onChange={(e) => setSelectedRetailer(e.target.value)}
            disabled={loading}
            className="w-full px-2 py-1 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          >
            <option value="">
              {loading ? "Loading retailers..." : "-- Select Retailer --"}
            </option>
            {retailers.map((retailer) => (
              <option key={retailer.value} value={retailer.value}>
                {retailer.label}
              </option>
            ))}
          </select>
        </div>

        {/* Courier */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Select Courier Partner <span className="text-red-500">*</span>
          </label>
          <select
            value={selectedCourier}
            onChange={(e) => setSelectedCourier(e.target.value)}
            className="w-full px-2 py-1 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          >
            <option value="">-- Select Courier Partner --</option>
            {courierPartners.map((courier) => (
              <option key={courier.id} value={courier.id}>
                {courier.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      </div>
      {/* ================= FILE UPLOAD ================= */}
      <div className="bg-white rounded-lg shadow-md p-3 sm:p-2 lg:p-4 mb-4 sm:mb-6 mt-4">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-gray-700">
            Zone Pricing CSV <span className="text-red-500">*</span>
          </label>
          <label className="cursor-pointer border border-dashed border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-600 hover:border-indigo-400">
            {zoneFile ? zoneFile.name : "Choose Zone Pricing CSV"}
            <input
              type="file"
              accept=".csv"
              onChange={(e) => setZoneFile(e.target.files[0])}
              className="hidden"
            />
          </label>
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-gray-700">
            VAS Pricing CSV <span className="text-red-500">*</span>
          </label>
          <label className="cursor-pointer border border-dashed border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-600 hover:border-indigo-400">
            {vasFile ? vasFile.name : "Choose VAS Pricing CSV"}
            <input
              type="file"
              accept=".csv"
              onChange={(e) => setVasFile(e.target.files[0])}
              className="hidden"
            />
          </label>
        </div>

        <button
          onClick={handleUpload}
          disabled={loading}
          className="h-[36px] px-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl text-xs font-semibold disabled:opacity-60"
        >
          {loading ? "Uploading..." : "Upload Pricing"}
        </button>
      </div>
      </div>

      {error && <p className="text-red-500 text-xs">{error}</p>}
    </div>
  );
};

export default PricingTemplateUpload;
